import PropTypes from 'prop-types';
import React from 'react';
import {
  defineMessages,
  injectIntl,
  intlShape,
  FormattedMessage,
} from 'react-intl';
import { connect } from 'react-redux';

import Container from 'brastrap/common/container/Container';
import Grid from 'brastrap/helpers/l-grid/l-grid';
import Link from 'brastrap/containers/link/LinkContainer';
import Login from './LoginContainer';
import Register from './RegisterContainer';
import Meta from '../../../containers/MetaContainer';

const messages = defineMessages({
  existing: {
    id: 'auth.existing-customer',
    defaultMessage: 'Existing Customer',
  },
  pleaseLogin: {
    id: 'auth.please-login',
    defaultMessage: 'Please log in below',
  },
  newCustomer: { id: 'auth.new-customer', defaultMessage: 'New Customer' },
  pleaseRegister: {
    id: 'auth.please-register',
    defaultMessage: 'Register with us for future convenience',
  },
  forwarding: {
    id: 'auth.forwarding',
    defaultMessage: 'Forwarding you to {link}...',
  },
  yourAccount: { id: 'auth.your-account', defaultMessage: 'your account' },
  title: { id: 'auth.title', defaultMessage: 'Login' },
  description: {
    id: 'auth.description',
    defaultMessage:
      'Existing customer? Log in to your account here.' +
      ' New customer? Register with us for quick checkout, access to your order status and order history.',
  },
});

const AuthPage = props => {
  const {
    isAuthenticated,
    intl: { formatMessage },
  } = props;

  if (isAuthenticated) {
    return (
      <div className="c-page__main">
        <Grid>
          <Grid.Unit className="u-padding">
            <div className="u-center">
              <FormattedMessage
                {...messages.forwarding}
                values={{
                  link: (
                    <Link href="/account/personal">
                      <FormattedMessage {...messages.yourAccount} />
                    </Link>
                  ),
                }}
              />
            </div>
          </Grid.Unit>
        </Grid>
      </div>
    );
  }

  return (
    <Meta
      title={formatMessage(messages.title)}
      description={formatMessage(messages.description)}
    >
      <div className="c-page__main">
        <Grid>
          <Grid.Unit className="u-padding">
            <Container
              id="c-page__login"
              modifiers="no-shadow"
              title={formatMessage(messages.existing)}
              introduction={formatMessage(messages.pleaseLogin)}
            >
              <Login />
            </Container>
          </Grid.Unit>

          <Grid.Unit className="u-padding">
            <Container
              id="c-page__register"
              modifiers="no-shadow"
              title={formatMessage(messages.newCustomer)}
              introduction={formatMessage(messages.pleaseRegister)}
            >
              <Register />
            </Container>
          </Grid.Unit>
        </Grid>
      </div>
    </Meta>
  );
};

AuthPage.propTypes = {
  intl: intlShape,
  isAuthenticated: PropTypes.bool.isRequired,
  forwardToAccount: PropTypes.func,
  basePath: PropTypes.string,
};

AuthPage.defaultProps = {
  isAuthenticated: false,
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default injectIntl(connect(mapStateToProps)(AuthPage));

export const UnwrappedAuthPage = AuthPage;
